import '@pec/aion-ui-core/index.css';
import 'react-phone-input-2/lib/material.css';
import './index.css';
import '@pec/aion-ui-i18next';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { App } from './App';

ReactDOM.render(<App />, document.getElementById('root'));
